export default function contractStatus(status) {
    switch (status) {
        case 'draft': return 'Draft';
        case 'requested': return 'Requested';
        case 'in_the_market': return 'In the market';
        case 'broker_review': return 'Broker Review';
        case 'reviewing': return 'Reviewing';
        case 'firm_order': return 'Firm order';
        case 'offered': return 'Offered';
        case 'accepted': return 'Accepted';
        case 'approved': return 'Approved';
        case 'declined': return 'Declined';
        case 'ntu': return 'NTU';
        case 'expired': return 'Expired';
        case 'cancelled': return 'Cancelled';
        case 'closed': return 'Closed';
        case 'firm_ordered': return 'Firm ordered';
        case 'bound': return 'Bound';
        case 'query': return 'Query';
        case 'off_risk': return 'Off Contract';

        default: return status;
    }
}
